import { NextSeo } from "next-seo";
import Head from "next/head";
import { AppConfig } from "../../../config";

type IMetaProps = {
  title: string;
  description: string;
  canonical?: string;
  image?: {
    url: string;
    width?: number;
    height?: number;
    alt?: string;
  };
};

export default function Meta(props: IMetaProps) {
  return (
    <>
      <Head>
        {process.env.NODE_ENV === "production" ? (
          <meta name="robots" content="index,follow" />
        ) : (
          <meta name="robots" content="noindex,nofollow" />
        )}
      </Head>
      <NextSeo
        title={props.title}
        description={props.description}
        canonical={props.canonical}
        openGraph={{
          title: props.title,
          description: props.description,
          url: props.canonical,
          locale: AppConfig.locale,
          site_name: AppConfig.site_name,
          images: props.image ? [props.image] : undefined,
        }}
      />
    </>
  );
}
